import React from 'react';
import { Controller } from 'react-hook-form';
import DatePickerInput from '../DatePicker/DatePickerInput';

function DatePicker({
  rules,
  errorMessage,
  control,
  fieldName,
  value,
  classLabel,
  classPicker,
  register,
  Label,
  disabled,
  closeFilter,
  setValue
}) {
  return (
    <>
      <div className={classLabel}>{Label}</div>
      <div className={classPicker}>
        <Controller
          control={control}
          name={fieldName}
          rules={rules}
          render={({ field }) => (
            <DatePickerInput
              field={field}
              value={value}
              fieldName={fieldName}
              register={register}
              disabled={disabled}
              closeFilter={closeFilter}
              setValue={setValue}
            />
          )}
        />
        <span className='font-semibold text-secondary-red'>{errorMessage}</span>
      </div>
    </>
  );
}

export default React.memo(DatePicker);
